import { SxProps, Theme } from '@mui/material';

/**
 * Styles for SelectContextItem component.
 */
export const selectContextItemStyles: Record<string, SxProps<Theme>> = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    mb: '2px',
  },

  dropdownContainer: {
    ml: '32px',
    mt: 1,
  },

  formControl: {
    width: '100%',
  },

  select: {
    bgcolor: 'background.paper',
    fontSize: '14px',
    '& .MuiSelect-select': {
      padding: '10px 12px',
      border: '1px solid',
      borderColor: 'divider',
      borderRadius: '8px',
      display: 'flex',
      alignItems: 'center',
      '&:focus': {
        borderColor: 'primary.main',
        bgcolor: 'background.paper',
      },
    },
    '& .MuiOutlinedInput-notchedOutline': { border: 'none' },
    '& .MuiSelect-icon': { color: 'text.secondary', fontSize: '20px' },
  },

  menuPaper: {
    maxHeight: 220,
    mt: 0.5,
  },

  menu: {
    zIndex: 1000001,
  },

  menuItem: {
    alignItems: 'center',
  },

  menuCheckbox: {
    padding: 0,
    marginRight: '8px',
  },

  // Selected value text - override body2 secondary color to primary
  selectedValueText: {
    color: 'text.primary',
  },
};
